
export default {
    name: 'DropdownMessageComponent',
}
